import React, {useEffect, useState} from 'react';
import { actionsType } from 'config/constants';
import PubSub from 'services/PubSub/';
import Modal from "components/Modal";
import ContentReschedule from './ContentReschedule';
import style from './style.scss'; //NOSONAR

let actions = []; 
let success = null;

const ModalConfirmReschedule = () => {
    const [order, setOrder] = useState('');

    useEffect(()=> {
        actions.push(PubSub.register(actionsType.MODAL.RESCHEDULE_CONFIRM_OPEN, _open));

        return function cleanup () {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    },[])

    const _open = (payload) => {
        setOrder(payload.value.orderId);
        success = payload.value.callbackSuccess;
    }

    const closeRescheduleMessage = () => {
        setTimeout(()=> PubSub.dispatch(actionsType.MODAL.RESCHEDULE_CONFIRM_CLOSE),0);
    }

    return (
        <Modal customClass="modal-confirm-reschedule" actionOpen={actionsType.MODAL.RESCHEDULE_CONFIRM_OPEN} actionClose={actionsType.MODAL.RESCHEDULE_CONFIRM_CLOSE}>
            <ContentReschedule closeRescheduleMessage={closeRescheduleMessage} orderId={order} success={success}/>
        </Modal>
    )
}

export default ModalConfirmReschedule;